//dependencias
import React, { Component } from 'react';

//componentes
import PlanificacionAprobados from './planificacionAprobados'

class Index extends Component {

    render(){
        return(
            <div>
                <PlanificacionAprobados />
            </div>
        );
    }

}
export default Index;